import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Form, Button, Input, notification } from "antd";
import { useHistory, Link } from "react-router-dom";
import FormWrapper from "../../../../../shared/components/otop/FormWrapper";

const FormProduct = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const { createCategory, editCategory, categoryDetails, id } =props;
  const [isDisabled, setIsDisabled] = useState(false);
  const [form] = Form.useForm();
  let isEdit = id;

  useEffect(() => {
    window.scrollTo(0, 0);

    if (isEdit && categoryDetails) {
      const { attributes } = categoryDetails;
      form.setFieldsValue({
        name: attributes.name ? attributes.name : "",
      });
    }
  }, [categoryDetails]);

  const onFinish = (values, e) => {
    // console.log("values", values)
    if (isEdit) {
      dispatch(editCategory(values, id, callback));
      setIsDisabled(true);
    } else {
      dispatch(createCategory(values, callback));
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const callback = (response, error) => {
    if (response) {
      const { status_code } = response;
      const { data } = response;
      if (data) {
        notification.success({ message: 'Category is successfully created!' });
        history.push('/otop-hub/admin/categories');
      } else if (status_code === "PRODUCT_UPDATE") {
        notification.success({ message: 'Category is successfully updated!' });
        history.push('/otop-hub/admin/categories');
      } else if (status_code === "INVALID_DATA") {
        if (response.errors.name) {
          form.setFields([
            {
              name: "name",
              errors: [`${response.errors.name}`],
            },
          ]);
        }
      }
    }
  };

  return (
    <FormWrapper>
      <Form
        form={form}
        onFinish={onFinish}
        name="formTag"
        className="shadow pt-10 px-10"
        onFinishFailed={onFinishFailed}
        initialValues={{ remember: true }}
      >
        <div className="flex w-5/6 mt-5">
          <div className="w-1/2 mr-10 pr-5">
            <div>
              <p className="xs-title">Category Name</p>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please input your category name!",
                  },
                ]}
              >
                <Input placeholder="Category Name" />
              </Form.Item>
            </div>
          </div>
        </div>
        <div className="border-b-2">&nbsp;</div>
        <div className="py-10 flex">
          {isEdit ? (
            <Button htmlType="submit" className="mr-5 flex items-center">
              Edit Category
            </Button>
          ) : (
            <Button
              htmlType="submit"
              disabled={isDisabled}
              className="mr-5 flex items-center"
            >
              Add Category
            </Button>
          )}
          <Link to="/otop-hub/admin/categories">
            <Button className="flex items-center">Cancel</Button>
          </Link>
        </div>
      </Form>
    </FormWrapper>
  );
};

export default FormProduct;
